import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { UrlConstants } from "../models/urlConstants"; 
import { CommissionResponse } from '../models/commission-response';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private commissionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false); 

  constructor(private http: HttpClient) {}

  fetchCommissions(): Observable<CommissionResponse> {
    return this.http.get<CommissionResponse>(`${UrlConstants.backofficeUrl}/api/Settings/GetConfiguredCommissions`).pipe(
      catchError((err) => {
        return throwError(err); 
      })
    );
  }
  createOrder(orderData: any): Observable<any> {
    return this.http.post(`${UrlConstants.backofficeUrl}/api/Orders/PostOrder`, orderData);
  }

  calculateFees(orderValue: number,CurrencyId:number,avgCommission:number, minCommission:number, minCommissionUSD:number): number {

    let feePercentage = avgCommission;
    if (orderValue === 0) {
      feePercentage = 0;
      return 0;
    }

    let totalFees = orderValue * feePercentage;

    if (CurrencyId === 1) { 
      if (totalFees < minCommission) {
        totalFees = minCommission;
      }
    } else {
      if (totalFees < minCommissionUSD) {
        totalFees = minCommissionUSD;
      }
    }

    return totalFees;
  }

  get commissionsFetched(): Observable<boolean> {
    return this.commissionSubject.asObservable();
  }
}
